import React, {useEffect, useState, Fragment, useContext} from "react";
import Layout from 'components/sales/layout/layout';
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from "../../sales/Input/constantInput/constantInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import FileUpload from "../../sales/fileUpload/fileUpload";
import Images from "../../../assets/images/imageData";
import ModalPop from "../../sales/modal/modal";
import "../../UserConfig/UserRequest/Request.css";
import {
    REGENERATION_INVOICE_USE_CASE_ID,
    getRegenerationInvoicePiTiErrors,
} from "../../UserConfig/UserRequest/userRequestPiTiValidation";

const Request = ({
    getUseCase,
    userRequest,
    clearUserRequest,
    reconPiTiValidation,
    mrfNumberByInvoiceNumber=[],
    useCasesList=[],
    saveUserRequest=[],
    documentUploadUrlPublic,
    documentUrlDataPublic,
    history
}) => {

    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [isSuccessModal, setIsSuccessModal] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('')
    const [mrfDropdown, setMrfDropdown] = useState([]);
    const [isFetchingMrf, setIsFetchingMrf] = useState(false);
    const [mrfError, setMrfError] = useState('');
    const [hasFetchedMrf, setHasFetchedMrf] = useState(false);

    const [inputList, setInputList] = useState([
        {
            use_case_id:'',
            pi_no:'',
            ti_no:'',
            user_remark:'',
            user_attachment:[]
        }
    ]);

    useEffect( () => {
        clearUserRequest()
        ;(async () => {
            setIsLoading(true)
            await getUseCase()
            setIsLoading(false)
        })()
        return () => {
            clearUserRequest()
        }
    }, [])

    const handleModalHide = (url = '') => {
        setIsModal(false);
        setIsSuccessModal(false);
        if(url !== ''){
            history.push(`${baseUrl}/${url}`);
        }
    };

    const handleInputValue = (key, val) => {
        let list = [...inputList]
        inputList[0][key] = val
        setInputList(list)
        if (key === 'ti_no' || key === 'use_case_id') {
            setMrfDropdown([])
            setMrfError('')
            setHasFetchedMrf(false)
            inputList[0].mrf_no = ''
        }
    }

    const parseInvoiceNumbers = (value) =>
        String(value || '')
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean)

    const handleFetchMrf = async () => {
        const invoiceNumbers = parseInvoiceNumbers(inputList[0]?.ti_no)
        if (invoiceNumbers.length === 0) {
            setMrfError(localization.tiNoRequiredForMrf)
            setMrfDropdown([])
            return
        }

        setMrfError('')
        setIsFetchingMrf(true)
        const res = await reconPiTiValidation(invoiceNumbers, { isPi: false, isTi: true })
        setIsFetchingMrf(false)
        setHasFetchedMrf(true)

        const rawMrf = res?.mrfDropdown ?? []
        const fetchedMrf = Array.isArray(rawMrf) ? rawMrf : []

        if (fetchedMrf.length === 0) {
            setMrfError(res?.message || localization.noMrfFound)
        }
        setMrfDropdown(fetchedMrf)

        let list = [...inputList]
        list[0].mrf_no = ''
        setInputList(list)
    }

    const handleCarnivalChange = (value) => {
        const selectedReason = value?.id || ''
        let list = [...inputList]
        list[0].reason_for_cancellation = selectedReason
        list[0].user_remark = selectedReason === 'Other' ? '' : selectedReason
        setInputList(list)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = [...inputList]

        if (isRegenerationInvoice && (piTiErrors.piError || piTiErrors.tiError)) {
            return
        }

        if (isRegenerationInvoice && !hasFetchedMrf) {
            return
        }

        setIsLoading(true)
        setIsModal(false)
        setIsSuccessModal(false)
        setError(null)
        await userRequest(list[0])
        setIsLoading(false)
    }

    useEffect(() => {
        if(saveUserRequest && parseInt(saveUserRequest?.status) === 200){
            setIsSuccessModal(true)
            setMessage(saveUserRequest?.message)
            setError(null)
        }else if(saveUserRequest && saveUserRequest?.status !== undefined && parseInt(saveUserRequest?.status) !== 200){
            setIsModal(true)
            setIsSuccessModal(false)
            setError(saveUserRequest?.message)
        }
    }, [saveUserRequest])

    const isRegenerationInvoice =
        parseInt(inputList[0]?.use_case_id, 10) === REGENERATION_INVOICE_USE_CASE_ID;

    const piTiErrors = isRegenerationInvoice
        ? getRegenerationInvoicePiTiErrors(
            inputList[0]?.pi_no,
            inputList[0]?.ti_no,
            {
                piTiEitherSingleRequired: localization.piTiEitherSingleRequired,
            }
        )
        : { piError: '', tiError: '' };

    const reinvoicingReasons = [
        {
            id: "Revise Client Details",
            name: "Revise Client Details"
        },
        {
            id: "Incorrect Invoice Details",
            name: "Incorrect Invoice Details"
        },
        {
            id: "Date Change",
            name: "Date Change"
        },
        {
            id: "Increment Issues",
            name: "Increment Issues"
        },
        {
            id: "Split Invoice",
            name: "Split Invoice"
        },
        {
            id: "Consolidate Invoice",
            name: "Consolidate Invoice"
        },
        {
            id: "Late Fee",
            name: "Late Fee"
        },
        {
            id: "Other",
            name: "Other"
        }
    ]

    const isSubmitDisabled =
        isRegenerationInvoice && !hasFetchedMrf;

    return (
        <>
            <Layout title={localization.userRequest} isLoading={isLoading} isGoback={true}>
                {error !== null ?
                    <>
                        <ModalPop
                            title={localization.failed}
                            show={isModal}
                            handleModalHide={handleModalHide}
                        >
                            <div className="text-center">
                                <div className="success">
                                    <img src={Images?.alert} alt="" />
                                </div>
                                <h5>{error}</h5>
                            </div>
                        </ModalPop>
                        </>
                    :
                    <>
                        <ModalPop
                            title={localization.conf}
                            show={isSuccessModal}
                            handleModalHide={()=> handleModalHide('user-request-list')}
                        >
                            <div className="text-center">
                                <div className="success">
                                    <img src={Images?.tick} alt="" />
                                </div>
                                <h5>{message}</h5>
                            </div>
                        </ModalPop>
                    </>
                }

                <form onSubmit={(e) => { handleSubmit(e) }}>
                    <div className="panel-card card-details uc-user-request-form" width="100%">
                        <div className="panel-heading">{localization.userRequest}</div>
                        <div className="panel-body uc-user-request-form__body">
                            <div className="uc-user-request-form__fields">
                                <div className="uc-user-request-form__field-col uc-user-request-form__field-col--full">
                                    <DropDownInput
                                        data={useCasesList}
                                        label={localization.useCase}
                                        required
                                        errorMsg={localization.requiredName}
                                        isStarRequired={true}
                                        getIdValue={(value) => {
                                            handleInputValue('use_case_id', value?.id)
                                        }}
                                    />
                                </div>

                                <div className="uc-user-request-form__field-col uc-user-request-form__field-col--full">
                                    <ConstantInput
                                        label={isRegenerationInvoice ? localization.tiNoCommaSeparated : localization.tiNo}
                                        fullWidth
                                        type="text"
                                        value={inputList[0]?.ti_no}
                                        isStarRequired = {isRegenerationInvoice}
                                        required = {isRegenerationInvoice}
                                        blockError={!!piTiErrors.tiError}
                                        errorMsg={piTiErrors.tiError}
                                        handleChange={(val) => {
                                            handleInputValue('ti_no', val)
                                        }}
                                    />
                                </div>
                                {isRegenerationInvoice && (
                                    <div className="uc-user-request-form__mrf-panel">
                                        <div className="uc-user-request-form__mrf-panel-header">
                                            <h6 className="uc-user-request-form__mrf-panel-title">
                                                {localization.fetchMrfNumbers}
                                            </h6>
                                            <span className="uc-user-request-form__mrf-panel-badge">Required</span>
                                        </div>
                                        <p className="uc-user-request-form__mrf-hint">
                                            {localization.mrfFetchHint}
                                        </p>
                                        <div className="uc-user-request-form__mrf-actions">
                                            <button
                                                type="button"
                                                className="btn btn-transparent btn-sm uc-user-request-form__fetch-btn"
                                                disabled={isFetchingMrf || !inputList[0]?.ti_no?.trim()}
                                                onClick={handleFetchMrf}
                                            >
                                                {isFetchingMrf ? localization.fetchingMrf : localization.fetchMrfNumbers}
                                            </button>
                                        </div>
                                        {mrfError !== '' && (
                                            <p className="uc-user-request-form__mrf-status uc-user-request-form__mrf-status--error">
                                                {mrfError}
                                            </p>
                                        )}
                                        {hasFetchedMrf && mrfError === '' && mrfDropdown.length > 0 && (
                                            <p className="uc-user-request-form__mrf-status uc-user-request-form__mrf-status--success">
                                                {localization.mrfFoundCount.replace('{count}', mrfDropdown.length)}
                                            </p>
                                        )}
                                        {mrfDropdown.length > 0 && (
                                            <div className="uc-user-request-form__mrf-dropdown">
                                                <DropDownInput
                                                    data={mrfDropdown}
                                                    fullWidth
                                                    label={localization.mrfNumbers}
                                                    value={inputList[0]?.mrf_no}
                                                    getIdValue={(value) => {
                                                        handleInputValue('mrf_no', value?.id || '')
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="uc-user-request-form__field-col uc-user-request-form__field-col--full">
                                    <ConstantInput
                                        label={isRegenerationInvoice ? localization.piNoCommaSeparated : localization.piNo}
                                        fullWidth
                                        type="text"
                                        value={inputList[0]?.pi_no}
                                        isStarRequired = {isRegenerationInvoice}
                                        required = {isRegenerationInvoice}
                                        blockError={!!piTiErrors.piError}
                                        errorMsg={piTiErrors.piError}
                                        handleChange={(val) => {
                                            handleInputValue('pi_no', val)
                                        }}
                                    />
                                </div>
                                {isRegenerationInvoice && (
                                    <div className="uc-user-request-form__field-col uc-user-request-form__field-col--full">
                                        <DropDownInput
                                            data={reinvoicingReasons}
                                            fullWidth
                                            label="Reason for Cancellation"
                                            value={inputList[0]?.reason_for_cancellation}
                                            getIdValue={handleCarnivalChange}
                                            isStarRequired={true}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {(!isRegenerationInvoice || inputList[0]?.reason_for_cancellation === "Other") && (
                                    <div className="uc-user-request-form__field-col uc-user-request-form__field-col--full">
                                        <TextAreaInput
                                            type="text"
                                            rows={4}
                                            label={isRegenerationInvoice ? localization.reasonForConversion : localization.remark}
                                            inputValue={inputList[0]?.user_remark || ''}
                                            handleChange={(e) => {
                                                handleInputValue('user_remark', e.target.value)
                                            }}
                                            required
                                            isStarRequired={true}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="uc-user-request-form__actions">
                                <FileUpload
                                    id="profile"
                                    accept=".pdf,.png,.jpg,.jpeg,.doc, .xlsx,.csv,.doc,.pdf"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) =>
                                        handleInputValue('user_attachment', val)
                                    }
                                    multiple={true}
                                >
                                    <span className="btn btn-transparent">
                                        {isRegenerationInvoice ? localization.attachmentProof : localization.attachment}
                                        {isRegenerationInvoice && <span style={{color:'red'}}>*</span>}
                                    </span>
                                </FileUpload>
                                <div className="uc-user-request-form__actions-right">
                                    {isSubmitDisabled && (
                                        <p className="uc-user-request-form__submit-hint">
                                            {localization.fetchMrfBeforeSubmit}
                                        </p>
                                    )}
                                    <button
                                        disabled={isSubmitDisabled}
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        {localization.submit}
                                        <img src={Images?.ArrowRight} alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Layout>
        </>
    )
}

export default Request